<app-topheader></app-topheader>
<div class="obscrollingcontainer " [ngClass]="{nonIOS:nonIOSdevice}">

    <div class="container">
        <app-fancy-page-title topTitle="YOUR NEXT ADVENTURE" subTitle=""></app-fancy-page-title>



        <app-longgoldbar></app-longgoldbar>

        <div class="tenpxtop"></div>

        <app-onboard-rebooking></app-onboard-rebooking>
    </div>
</div>
<app-bottommenu></app-bottommenu>